import type { PropsWithChildren } from 'react';
import { Result } from 'antd';
import { usePermissions } from './usePermissions.js';

export function Require({ perm, children }: PropsWithChildren<{ perm: string }>) {
  const { has } = usePermissions();
  if (!has(perm)) {
    return <Result status="403" title="Forbidden" subTitle="Missing permission" />;
  }
  return children as JSX.Element;
}
